import {forwardRef} from 'react';
import {BleskIcon} from '../types';
import {BaseIcon} from './BaseIcon';

export const Premium: BleskIcon = forwardRef(function Premium(props, ref) {
  return (
    <BaseIcon {...props} ref={ref}>
      <rect
        x="2.99634"
        y="2.99634"
        width="18.0075"
        height="18.0075"
        rx="5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.001 10.9996L16.2245 9.51725C16.378 9.41493 16.5754 9.40539 16.738 9.49243C16.9007 9.57948 17.0022 9.74898 17.0022 9.93346V15.0013C17.0022 15.5538 16.5543 16.0017 16.0018 16.0017H7.99846C7.44595 16.0017 6.99805 15.5538 6.99805 15.0013V9.93346C6.99805 9.74899 7.09959 9.5795 7.26224 9.49246C7.42488 9.40542 7.62223 9.41496 7.77572 9.51728L9.9993 10.9996L11.584 8.62265C11.6767 8.48349 11.8329 8.3999 12.0002 8.3999C12.1674 8.3999 12.3236 8.48349 12.4164 8.62265L14.001 10.9996Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  );
});
